import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AmountBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  gap: "5px",
});

export const AbsensesMainContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ExtrahoursMainContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ExtrahoursAmount = styled(Grid)({
  fontSize: "1em",
  fontWeight: "bold",
  color: "darkblue",
});

export const ClientVendotAmountBlock = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
});

export const ClientVendorInfo = styled(Grid)({
  display: "flex",
  flexDirection: "column",
});

export const AmountContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "5px",
  justifyContent: "flex-end",
});

export const ExpenseInfoContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ExpenseIconContainer = styled(Grid)({
  width: "40px",
});
